import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as employmentTypesServiceClear } from './employmentTypesService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'employmentTypes',
  serviceTableName: 'employmentTypesService',
  serviceClearFunction: employmentTypesServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.employmentType]),
});
